// extracted by mini-css-extract-plugin
module.exports = {"InvalidFeedback":"SettlementForm_InvalidFeedback__wg2MV","TotalAmountView":"SettlementForm_TotalAmountView__RJB3c","Description":"SettlementForm_Description__GK35V"};